export const REQUESTS_ABSENCE_CREATE_PATH = "/requests/absence/create";
export const REQUESTS_ABSENCE_EDIT_PATH = "/requests/absence/edit/:id";
